﻿import React from 'react';
import { H1 } from '@Elements/Fonts';

export default function Errorpage(): JSX.Element {
    return (
        <H1>Fel</H1>
    );
}